import { motion } from "framer-motion";

export default function InteriorHero({ img, eyebrow, title, sub, children }) {
  return (
    <header className="relative min-h-[70vh] flex items-end overflow-hidden bg-brand-dark">
      {img && <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover" />}
      <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/60 to-brand-dark/40" />
      <div className="grain" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pb-16 pt-32 w-full">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-brand-orange" />
          <span className="text-brand-offwhite/70 text-xs tracking-[0.25em] uppercase font-medium">{eyebrow}</span>
        </motion.div>
        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-semibold text-brand-offwhite text-4xl sm:text-5xl lg:text-7xl tracking-tighter leading-[0.98] max-w-4xl">
          {title}
        </motion.h1>
        {sub && (
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.8 }}
            className="mt-6 max-w-2xl text-lg text-brand-offwhite/75 leading-relaxed">{sub}</motion.p>
        )}
        {children}
      </div>
    </header>
  );
}
